<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
  </div>
</template>

<script>
  import Footer from './components/Footer.vue'
  import Header from './components/Header.vue'

  export default {
    components: {
      Header,
      Footer
    }
  }
</script>
<style lang="scss">
  .w-1400px {
    width: 1400px;
    margin: 0 auto;
  }

  .w-100vw {
    width: 100vw;
    /* display: flex; */
    /* justify-content: center; */
  }
</style>